import { render, staticRenderFns } from "./depart-tree-new.vue?vue&type=template&id=5c3dbd40&scoped=true&"
import script from "./depart-tree-new.vue?vue&type=script&lang=js&"
export * from "./depart-tree-new.vue?vue&type=script&lang=js&"
import style0 from "./depart-tree-new.vue?vue&type=style&index=0&id=5c3dbd40&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c3dbd40",
  null
  
)

export default component.exports